import React from 'react';
import '../Style/apptrends.css';

import trapLeft from "../assets/left-corner.png";   
import trapRight from "../assets/right-corner.png"; 

const industries = [
  {
    id: 1,
    // icon: ecom,
    title: 'Payment Gateway Integration',
    description: 'Integrate trusted payment solutions like Razorpay, Stripe, PayPal, Apple Pay, Google Pay, and other secure payment gateways for seamless transactions.',
  },
  {
    id: 2,
    // icon: healthcare,
    title: 'Push Notification System',
    description: 'Increase user engagement with personalized push notifications, promotional campaigns, reminders, and real-time alerts.',
  },
  {
    id: 3,
    // icon: realestate,
    title: 'Analytics & User Insights',
    description: 'Track user behavior, app performance, and business metrics with integrated analytics platforms to make informed decisions.',
  },
  {
    id: 4,
    // icon: education,
    title: 'API & Third-Party Integrations',
    description: 'Connect your mobile application with CRMs, ERPs, payment gateways, maps, cloud services, SMS, email platforms, and external APIs.',
  },
  {
    id: 5,
    // icon: hospitality,
    title: 'IoT App Development',
    description: "Develop intelligent mobile applications that connect with smart devices, sensors, wearables, and IoT ecosystems for real-time monitoring and automation",
  },
  {
    id: 6,
    // icon: technology,
    title: 'Single Sign-On (SSO) Authentication',
    description: 'Enable secure login using Google, Apple, Microsoft, Facebook, or enterprise authentication providers for a seamless user experience.',
  },
  {
    id: 7,
    // icon: corporate,
    title: 'Enterprise Mobility Solutions',
    description: 'Build enterprise mobile applications that integrate with internal systems to improve workforce productivity and business operations.',
  },
  {
    id: 8,
    // icon: textile,
    title: 'AR & Mixed Reality Experiences',
    description: 'Create immersive augmented reality (AR) and mixed reality experiences for retail, education, healthcare, manufacturing, and training applications.',
  },
];

const GdIndustries = () => {
  return (
    <section className="gdi-section">

        <img src={trapLeft} alt="" className="trap-left" />
        <img src={trapRight} alt="" className="trap-right" />

      <div className="gdi-inner">
        <h2 className="gdi-heading">Advanced Mobile App Features We Develop</h2>

        {/* Row 1 — 3 cards */}
        <div className="gdi-row gdi-row--3">
          {industries.slice(0, 3).map((item, i) => (
            <div className="gdi-card" key={item.id}>
              {i < 2 && <div className="gdi-vline" />}
              <div className="gdi-card__header">
                {/* <img src={item.icon} alt={item.title} className="gdi-card__icon" /> */}
                <h3 className="gdi-card__title">{item.title}</h3>
              </div>
              <p className="gdi-card__desc">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="gdi-hline" />

        {/* Row 2 — 3 cards */}
        <div className="gdi-row gdi-row--3">
          {industries.slice(3, 6).map((item, i) => (
            <div className="gdi-card" key={item.id}>
              {i < 2 && <div className="gdi-vline" />}
              <div className="gdi-card__header">
                {/* <img src={item.icon} alt={item.title} className="gdi-card__icon" /> */}
                <h3 className="gdi-card__title">{item.title}</h3>
              </div>
              <p className="gdi-card__desc">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="gdi-hline" />

        {/* Row 3 — 2 cards centered */}
        <div className="gdi-row gdi-row--2">
          {industries.slice(6, 8).map((item, i) => (
            <div className="gdi-card" key={item.id}>
              {i < 1 && <div className="gdi-vline" />}
              <div className="gdi-card__header">
                {/* <img src={item.icon} alt={item.title} className="gdi-card__icon" /> */}
                <h3 className="gdi-card__title">{item.title}</h3>
              </div>
              <p className="gdi-card__desc">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GdIndustries;